import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  moreDataRowContainer: (index, length, theme) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: index % 2 != 0 ? 1 : 0,
    borderBottomWidth: index % 2 != 0 && index != length - 1 ? 1 : 0,
    alignItems: 'center',
    borderColor: theme.colors.borderColorThree,
    paddingVertical: 12,
  }),
  moreDataContainer: showMoreData => ({
    marginTop: showMoreData.length ? 15 : 0,
  }),
  label: {
    flexShrink: 1,
    marginLeft: 15,
    fontSize: 15,
  },
  amount: {
    fontSize: 20,
  },
  unit: {
    marginLeft: 4,
    lineHeight: 23,
  },
  showMoreDataLeftItem: {
    flexShrink: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  showMoreDataRightItem: {
    maxWidth: '50%',
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'baseline',
  },
})
